import React, { useMemo } from 'react';
import { Image } from 'antd';
import { MessageQuestionIcon } from 'icons';

import { useAppDispatch, useAppSelector } from 'store';

import { setQuestionId, setTestFeedbackModal } from 'modules/global';

interface IProps {
  title?: string;
  testImage?: string;
  questionId?: number;
}

const TopSection: React.FC<IProps> = ({ title, testImage, questionId }) => {
  const dispatch = useAppDispatch();
  const test = useAppSelector(({ nationalCertificate }) => nationalCertificate.test?.test);

  const { index, total } = useMemo(() => {
  const questions = test?.questions ?? [];
  const total = questions.length;

  const index =
    (questions.findIndex(q => q?.question_id === questionId) ?? -1) + 1;

  return { index, total };
}, [test?.questions, questionId]);

  const onOpenFeedbackModal = () => {
    dispatch(setQuestionId(questionId as number));
    dispatch(setTestFeedbackModal(true));
  };

  return (
    <>
      <div className="flex items-center justify-between">
        <div className="text-xs text-gray-500">
          {index}/{total} • {test?.name}
        </div>
        <div onClick={onOpenFeedbackModal} className="flex cursor-pointer items-center gap-2 text-orange-400">
          <MessageQuestionIcon />
        </div>
      </div>
      <div className="transition-all duration-300">
        <div className="mt-3 whitespace-pre-line text-sm font-medium">{title}</div>
        {testImage && (
          <div className="mt-4 flex justify-center">
            <Image src={testImage} alt={title} loading="lazy" className="!rounded-xl" title="Test image" />
          </div>
        )}
      </div>
    </>
  );
};

export default TopSection;
